import { render, staticRenderFns } from "./issue_popover.vue?vue&type=template&id=07b9159e"
import script from "./issue_popover.vue?vue&type=script&lang=js"
export * from "./issue_popover.vue?vue&type=script&lang=js"
import style0 from "./issue_popover.vue?vue&type=style&index=0&id=07b9159e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports